/* eslint-disable react/jsx-handler-names */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import OKPDFViewer from 'components/commons/OKPdfViewer/OKPdfViewer.js';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import UtagHelper from 'utilities/utagHelper';
import { FormattedText, formatText } from 'core/i18n';
import { base64ToBlob, downloadAsFile } from 'utilities/APIRequestHelper';
import { getUserProfileData } from 'utilities/userProfile';
import { RELIABLE, PAGE_PRODUCT, recordEvent } from 'utilities/uTagging';
import { recordAndSavePage } from 'actions/errorViewNavigation';
import { PATH_CREDIT_CARD_INFO, CREDIT_CARD_INFO_PATH } from 'constants/uTagConstants/paths';
import { PROCESS_TYPE_ONBOARDING } from 'utilities/uTagConstants';
import { CREDIT_CARD } from 'constants/userProfile';
import cryptoJS from 'crypto-js';
import { bindActionCreators } from 'redux';

class CreditCardInePDF extends Component {
    componentDidMount() {
        const { userProfile, products, immStepsState, recordAndSavePage } = this.props;
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
        const { investmentType, userId, recordId, product, promoCode, identityMethod } = userProfile;

        window.scrollTo(0, 0);
        investmentType === CREDIT_CARD &&
            !immStepsState.get('welcomeCard') &&
            recordAndSavePage(
                PATH_CREDIT_CARD_INFO,
                recordId,
                userId,
                product,
                products.get('productsDescription'),
                promoCode ? promoCode : '',
                JointHolderInfo,
                RELIABLE[identityMethod],
                '',
                investmentType,
                {
                    tipoProceso: PROCESS_TYPE_ONBOARDING,
                    pasoProceso: CREDIT_CARD_INFO_PATH,
                    detalleProceso: '',
                    identificadorOnboarding: userProfile.docNumber
                        ? cryptoJS.SHA256(userProfile.docNumber).toString()
                        : '',
                }
            );
    }

    handlePrintPdf = () => {
        const { pdfFile } = this.props;
        const blob = new Blob([base64ToBlob(pdfFile)], { type: 'application/pdf' });
        const blobURL = window.URL.createObjectURL(blob);

        const noLocationWithScrollAndMenu = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,';
        const pdfWindowSize = 'resizable,screenX=50,screenY=50,width=850,height=1050';

        const pdfWindowParams = noLocationWithScrollAndMenu + pdfWindowSize;
        const pdfWindow = window.open(blobURL, '', pdfWindowParams);
        pdfWindow.print();
    };

    handleDocumentReaded = () => {
        this.props.handleDisableNextButton(false);
        this.recordIbanPollingStatusesEvent({
            eventTag: ``,
            eventAction: `scroll down`,
        });
    };

    recordIbanPollingStatusesEvent = ({ eventAction, eventTag }) => {
        const { encryptedDocNumber, recordId, userId, investmentType } = getUserProfileData(this.props);
        recordEvent(
            PATH_CREDIT_CARD_INFO,
            PAGE_PRODUCT,
            eventAction,
            eventTag,
            recordId,
            userId,
            RELIABLE[this.props.userProfile.identityMethod],
            investmentType,
            encryptedDocNumber,
            { categoriaEvento: PATH_CREDIT_CARD_INFO, accionEvento: eventAction, etiquetaEvento: eventTag }
        );
    };

    render() {
        const { pdfFile, togglingCondition } = this.props;

        return (
            <div className={'pdf-container'}>
                <ConditionalToggling condition={togglingCondition}>
                    <OKPDFViewer
                        showLogo
                        showScroll
                        displayScrollButton
                        viewerHeight={'455px'}
                        onDownload={() => {
                            downloadAsFile(base64ToBlob(pdfFile), 'application/pdf', `Contrato TDC.pdf`);
                        }}
                        onPrint={this.handlePrintPdf}
                        title={formatText('creditCardOffer-pdfPlaceholder')}
                        pdfFile={pdfFile}
                        handleDocumentReaded={this.handleDocumentReaded}
                    />
                </ConditionalToggling>
                <div className="font-heading6--book">
                    <FormattedText value="creditCardOffer-conditionText" />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userProfile: state.userProfile,
    immStepsState: state.steps,
    products: state.products,
});

const mapDispatchToProps = dispatch => ({
    recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreditCardInePDF);
